module.exports = __webpack_public_path__ + "media/images/email/tiktok-28e31b03ee4418c2cccbe25b77888c4b.png";